import { createContext } from 'react';

interface BlanksContext {
  labelsPosition: 'before' | 'below';
}

const blanksContext = createContext<BlanksContext>({ labelsPosition: 'before' });

export default blanksContext;
